module.exports = require('./dist/lib/head')
